const matchHills = (courseHills, runHill) => {
    // courseHills = {name: string, avgGrade: number, distMeters: number, stravaSegment: string}
    // runHill = {avgGrade: number, distMeters: number}
    const minMatchScore = 90;
    const scores = [];
    let bestMatchIndex = null;
    for (let i = 0; i < courseHills.length; i++) { // eslint-disable-line
        if (runHill) {
            const gradePercDiff = (courseHills[i].avgGrade - runHill.avgGrade)
                / courseHills[i].avgGrade;
            const lengthPercDiff = (courseHills[i].distMeters - runHill.distMeters)
                / courseHills[i].distMeters;
            const gradeScore = 1 - Math.abs(gradePercDiff);
            const lengthScore = 1 - Math.abs(lengthPercDiff);
            scores[i] = Math.round(((gradeScore + lengthScore) * 50), 1);
            if (Math.max(scores) > minMatchScore) {
                bestMatchIndex = scores.indexOf(Math.max(...scores));
            }
        }
    }

    const bestMatch = bestMatchIndex >= 0 ? { // cannot use truthy test because index 0 = false
        ...courseHills[bestMatchIndex],
        score: scores[bestMatchIndex],
    } : null;
    return bestMatch;
};

export default matchHills;



/** WEBPACK FOOTER **
 ** ./src/utils/matchHills.js
 **/